module.exports = __webpack_public_path__ + "static/story6-cta-1920x515-2466ef42f59af6dd79e47bb6c7da4d38.jpg";